import helpTemplate from './helpTemplate.html';

export default function ($stateProvider) {
    $stateProvider.state('help', {
        parent: 'ng-admin',
        url: '/help',
        template: helpTemplate
    });
};



// WEBPACK FOOTER //
// ./js/help/helpState.js